var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height container-img"},[_c('v-img',{staticClass:"img-vertical",attrs:{"cover":"","max-height":"100%","src":require("@/assets/imagenes_home/home_01_vertical.jpg")}}),_c('v-img',{staticClass:"img-hori",attrs:{"cover":"","src":require("@/assets/imagenes_home/home_01.jpg")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }